import { api } from "@/lib/api";
import { PipelinePage, money, fmtDate } from "@/pages/revenue/PipelinePage";

const STATUSES = ["OPEN", "SUBMITTED", "WON", "LOST", "CANCELLED"];
const cfg = {
  title: "Tenders", singular: "Tender", endpoint: "tenders", stateField: "status", states: STATUSES,
  description: "Bids you are preparing or have submitted. Create the priced proposal from here.",
  fields: [
    { key: "title", label: "Tender title", required: true, wide: true },
    { key: "client_id", label: "Client", type: "client" },
    { key: "status", label: "Status", type: "select", options: STATUSES, default: "OPEN" },
    { key: "tender_no", label: "Tender / NIT number" }, { key: "submission_date", label: "Submission date", type: "date" },
    { key: "estimated_value", label: "Estimated value (₹)", type: "number" }, { key: "emd_amount", label: "EMD amount (₹)", type: "number" },
    { key: "lost_reason", label: "Lost reason", wide: true },
    { key: "notes", label: "Notes", type: "textarea" },
  ],
  columns: [
    { label: "Tender no.", render: (r) => r.tender_no || "—" },
    { label: "Est. value", render: (r) => money(r.estimated_value) },
    { label: "EMD", render: (r) => money(r.emd_amount) },
    { label: "Due", render: (r) => fmtDate(r.submission_date) },
  ],
  stats: (rows) => [
    { label: "Open / submitted", value: rows.filter((r) => ["OPEN", "SUBMITTED"].includes(r.status)).length, color: "blue" },
    { label: "EMD blocked", value: money(rows.filter((r) => ["OPEN", "SUBMITTED"].includes(r.status)).reduce((s, r) => s + Number(r.emd_amount || 0), 0)), color: "orange" },
    { label: "Won", value: rows.filter((r) => r.status === "WON").length, color: "green" },
    { label: "Lost", value: rows.filter((r) => r.status === "LOST").length, color: "gray" },
  ],
  actions: [{ label: "Make proposal", show: (r) => !["LOST", "CANCELLED"].includes(r.status), run: async (r) => { const { data } = await api.post(`/pipeline/tenders/${r.id}/to-proposal`); return `Proposal ${data.code} created`; } }],
  csv: (r, cn) => ({ Code: r.code, Title: r.title, Client: cn(r.client_id), "Tender no": r.tender_no || "", Status: r.status, "Est. value": r.estimated_value ?? "", EMD: r.emd_amount ?? "", Due: r.submission_date || "" }),
};
export default function Tenders() { return <PipelinePage cfg={cfg} />; }
